import React from "react";
import { t } from '@common/helpers/translator';
import PropTypes from 'prop-types';
import Config from '@skin_config';
import { getAuthData } from "@common/helpers/auth";
import classnames from 'classnames';
import { useBalance } from "../../hooks/balance";

const BETSLIP_TYPE_SINGLE = 1;

const StaticStake = ({
  setStake,
  betSlipType,
  activeStake
}) => {
  const balance = useBalance();
  const authData = getAuthData();
  const staticStakes = Config.staticStakeCounts[authData.currency.toLowerCase()] || Config.staticStakeCounts.default

  const handleNumberFieldClick = (num) =>
    setStake(activeStake === num ? '' : num)

  const fillNumbers = () =>
    staticStakes.map(num => (
      <li
        key={num}
        onClick={() => handleNumberFieldClick(num)}
        className={classnames({ active: activeStake === num })}
      >
        <span>{num}</span>
      </li>
    ))

  const setMaxAvailableStake = () => setStake(balance)

  return (
    <div className={classnames('virtual-staticStack-wrapper', {
      'single-betslip-StaticStake': betSlipType === BETSLIP_TYPE_SINGLE
    })}>
      <div className="virtual-staticStack-m">
        <ul className="key-numbers-m staticStake">
          {fillNumbers()}
          <li onClick={setMaxAvailableStake}>
            <span>{t("MAX")}</span>
          </li>
        </ul>
      </div>
    </div>
  )
}

StaticStake.propTypes = {
  setStake: PropTypes.func.isRequired,
  currency: PropTypes.objectOf(PropTypes.any).isRequired,
  user: PropTypes.objectOf(PropTypes.any).isRequired,
  terminalBalance: PropTypes.any,
  betSlipType: PropTypes.number
};

export default StaticStake;